import styled from 'styled-components'

export const Area = styled.div`
  width: 100%;
  height: calc(100vh - 380px);
  min-height: 320px;
`

export const Container = styled.div`
  width: 100%;
  height: 100%;
  border: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.subtle};
  border-radius: ${props => props.theme.primitives.radius.radius2};
  overflow: hidden;
`

export const Iframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  display: block;
`
